'use strict';

module.exports = {
    ContactForm:      require('./contact-form.jsx'),
    Dialog:           require('./dialog.jsx'),
    Footer:           require('./footer.jsx'),
    FullOfficeBanner: require('./fulloffice-banner.jsx'),
    Howto:            require('./howto.jsx'),
    Header:           require('./header.jsx'),
    Media:            require('./media.jsx'),
    Pinterest:        require('./pinterest.jsx'),
    Overlay:          require('./overlay.jsx'),
    RecentlyViewed:   require('./recently-viewed.jsx'),
    Upsell:           require('./upsell.jsx'),
    Videoplayer:      require('./videoplayer.jsx'),
};



// WEBPACK FOOTER //
// ./src/components/components.jsx